export const getCharactersCount = (amount: number, max: number) =>
  `${amount?.toLocaleString() || 0}/${max?.toLocaleString() || 0}`;
